export { useGetCoveoAuthentication } from './useGetCoveoAuthentication';
